import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import VizSensor from 'react-visibility-sensor';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
// import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';

// import red from '@material-ui/core/colors/red';
import Icon from '@material-ui/core/Icon';

import './style.scss';
import { print } from 'shared/utils/Helpers';
import { Link, Redirect, withRouter } from 'react-router-dom'
import { format } from 'date-fns';

import Modal from 'shared/components/Modal';
import Moments from 'app/screens/Moments';
import { selectStory } from 'shared/actions/storyActions';
import { showNavBarHome, showNavBarStory } from 'shared/actions/navActions';
import { trackEvent } from 'shared/services/Analytics';
import config from 'shared/config/config';
import StoryService from 'shared/services/StoryService';
import ActionSheet from 'shared/components/ActionSheet';

const windowWidth = window.innerWidth;
const fullCardWidth = windowWidth * 0.75;
const cardWidth = (fullCardWidth < 300 ? fullCardWidth : 300) + 'px';

var simpleCardHeight = '6vw'; // lg
if (windowWidth < 1280) {
  // md
  simpleCardHeight = '12.5vw';
}
if (windowWidth < 960) {
  // sm
  simpleCardHeight = '25vw';
}
if (windowWidth < 600) {
  // xs
  simpleCardHeight = '50vw';
}

const styles = theme => ({
  media: {
    height: 300,
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  simpleCardWrapper: {
    position: 'relative',
    display: 'block',
    width: '100%',
    padding: '0.5rem'
  },
  simpleCard: {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: simpleCardHeight,
    overflow: 'hidden',
    borderRadius: '10px',
    boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)'
  },
  cardLabel: {
    fontSize: '1rem',
    padding: '10px',
    fontWeight: '400 !important',
    fontFamily: config.sub_font
  },
  cardLabelBg: {
    margin: '0 auto',
    maxWidth: 'calc(100% - 30px)',
    padding: '10px',
    background: config.pwa_card_label_bg_color,
    border: '2px solid ' + config.pwa_card_label_border_color,
    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    borderRadius: '3px',
    color: config.pwa_galleryimage_font_color
  }
});

class Story extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      visible: false,
      loaded: false
    }
  }

  shouldComponentUpdate(newProps, newState) {
    return this.state.isOpen !== newState.isOpen ||
      this.state.visible !== newState.visible ||
      this.state.loaded !== newState.loaded;
  }

  componentDidUpdate() {
    // hotfix
    window.CL = window.CL || {};
    window.CL.storyComponents = window.CL.storyComponents || {};
    window.CL.storyComponents[this.props.story.id] = this;
  }

  open() {
    const {
      story,
      showNavBarStory,
    } = this.props;

    this.setState({ isOpen: true });
    showNavBarStory();
    document.body.style.overflowY = 'hidden';

    new StoryService().markStoryViewed(story.id);

    // hotfix
    window.currentStoryComponent = this;
  }

  close() {
    this.setState({ isOpen: false });
    this.props.showNavBarHome();
    document.body.style.overflowY = 'scroll';

    // hotfix
    window.currentStoryComponent = null;
  }

  progress = () => {
    const { imageLoadProgress } = this.state;
    this.setState({ imageLoadProgress: imageLoadProgress >= 100 ? 0 : imageLoadProgress + 10 });
  }

  getDates() {
    const formatStr = 'MMMM d, y';
    const story = this.props.story;

    if (story.start_date && story.end_date) {
      let start = format(new Date(story.start_date), formatStr);
      let end = format(new Date(story.end_date), formatStr);

      if (start !== end) {
        return `${start} - ${end}`;
      }

      return start;
    }

    return format(new Date(story.createdAt), formatStr);
  }

  renderCardMedia = (classes) => {
    const { story } = this.props;

    if (story.cover_moment_thumb) {
      var imgStyle;
      if (story.cover_moment && story.cover_moment.height > story.cover_moment.width) {
        imgStyle = {
          width: '100%',
          height: 'auto',
          opacity: this.state.visible ? 1 : 0,
          transition: 'opacity 0.5s'
        }
      } else {
        imgStyle = {
          width: 'auto',
          height: '100%',
          opacity: this.state.visible ? 1 : 0,
          transition: 'opacity 0.5s'
        }

      }

      return (
        <CardContent
          className={classes.media}
          // image={this.props.story.cover_moment_thumb}
          src=""
          title={this.props.story.name}
          style={{
            height: "100%",
            width: "100%",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            padding: "0px",
            background: config.pwa_story_bg,
            overflow: 'hidden'
          }}
        >
          <VizSensor
            partialVisibility
            onChange={isVisible => {
              if (isVisible && !this.state.visible) {
                this.setState({ visible: true });
              }
            }}>
            <img
              src={(this.state.loaded && this.props.story.cover_moment_url) || (this.state.visible && this.props.story.cover_moment_thumb) || ''}
              style={imgStyle}
              alt={this.props.story.name}
              onLoad={() => {
                this.setState({ loaded: true })
                // print("image loaded for story: ", this.props.story.id);
                // this.setState({imageLoaded: true});
                //clearInterval(this.timer);
              }}
              onError={() => {
                // print("image error for story: ", this.props.story.id);
                // this.setState({imageLoaded: true});
                //clearInterval(this.timer);
              }}
            />
          </VizSensor>
        </CardContent>
        // <CardMedia
        //   className={classes.media}
        //   image={this.props.story.cover_moment_thumb}
        //   // image={ VIEW_MOMENT_URL + this.props.story.cover_moment_id + '&scale=p'}
        //   // image={"https://staging-api.capturelife.com/moment/url?id=665270&scale=p"}
        //   title={this.props.story.name}
        //   style={{height: "200px", flex: 1, flexDirection: "column", alignItems: "center"}}
        //   onLoad={()=>{
        //     print("image loaded for story: ", this.props.story.id);
        //   }}
        // />
      );
    } else if (!this.props.story.cover_moment_thumb && !this.props.story.cover_moment_error) {
      // clearInterval(this.timer);
      return (
        <CardContent
          style={{ height: "100%", width: "100%", flex: 1, flexDirection: "column", alignItems: "center" }}
        >
          <div style={{ marginTop: "50px" }}>
            <CircularProgress
              className={classes.progress}
              variant="determinate"
              value={this.state.imageLoadProgress}
            />
          </div>
        </CardContent>
      );
    } else if (!this.props.story.cover_moment_thumb && this.props.story.cover_moment_error) {
      // clearInterval(this.timer);
      return (
        <CardContent
          style={{ height: "100%", width: "100%", flex: 1 }}
        >
          <BrokenImageIcon style={{ marginTop: "40px", fill: "lightgray", fontSize: "100px" }} />
        </CardContent>
      );
    }
  }

  render() {
    const { classes, user, story } = this.props;

    const content = (
      <Moments story={story} />
    );

    let button = null;
    if (user.theme.simple_stories) {
      let textStyle = {
        float: 'left',
        marginBottom: '0.5rem',
        fontColor: '#191919',
        fontFamily: '"SF Pro Text Medium", sans-serif',
        fontSize: '17pt',
        fontWeight: 400
      }

      button = (
        <div className={classes.simpleCardWrapper} onClick={this.open.bind(this)}>
          <span style={textStyle}>
            {story.name}
          </span>
          <div className={classes.simpleCard}>
            {this.renderCardMedia(classes)}
          </div>
        </div>
      );

    } else {
      button = (
        <Card className="card-wrapper" style={{ margin: 'auto', borderRadius: '5px', width: cardWidth, height: cardWidth, opacity: 1 }}>
          <div className="card">
            {this.renderCardMedia(classes)}
            <CardActions className={classes.actions}
              style={{ display: 'block' }}
            >
              <div className="card-label-wrapper">
                <div className={classes.cardLabelBg}>
                  <Typography variant="h4" component="h4" className={classes.cardLabel} style={{ display: 'inline' }}>
                    <b>{story.name}</b> ({story.purchased_count})
                  </Typography>
                </div>
              </div>
            </CardActions>
          </div>
        </Card>
      );
    }

    const props = {
      user,
      story,
      content,
      button,
      openDuration: 1500,
      closeDuration: 300,
      rubberband: 50
    }

    return (
      <ActionSheet props={props} />
    );
  }
}

Story.propTypes = {
  classes: PropTypes.object.isRequired,
  story: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.userReducer.user,
  modals: state.modalReducer.modals
});

const StoryComponent = withStyles(styles, { withTheme: true })(Story)
export default connect(mapStateToProps, { selectStory, showNavBarHome, showNavBarStory })(withRouter(StoryComponent));
